var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoEliminarRojo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.removeRed{fill:#EA5455}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3569",
    className: "removeRed",
    d: "M16.94,6.7c0.2,0,0.39,0.09,0.52,0.23c0.13,0.15,0.2,0.36,0.18,0.56 c0,0.07-0.53,6.81-0.84,9.65c-0.05,1.61-1.39,2.87-3,2.83C12.52,19.99,11.25,20,10,20c-1.32,0-2.62-0.01-3.87-0.04 c-1.58,0.01-2.88-1.25-2.93-2.83c-0.31-2.85-0.84-9.58-0.85-9.65c-0.01-0.2,0.06-0.4,0.19-0.56C2.68,6.78,2.87,6.7,3.07,6.7H16.94z  M12.07,0c0.9,0.01,1.68,0.63,1.9,1.5l0,0l0.16,0.73c0.12,0.59,0.64,1.01,1.24,1.02h2.92c0.4,0,0.72,0.33,0.72,0.73l0,0l0,0v0.38 c0,0.4-0.31,0.72-0.71,0.73H1.71C1.32,5.08,1,4.76,1,4.36l0,0V3.98c-0.01-0.4,0.31-0.73,0.71-0.73l0,0h2.92 c0.6-0.01,1.12-0.43,1.24-1.01l0,0l0.15-0.68c0.21-0.91,1-1.55,1.92-1.56H12.07L12.07,0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoEliminarRojo);
export default __webpack_public_path__ + "static/media/icono-eliminar-rojo.c8ef6ce771828eb1938483adf5becf32.svg";
export { ForwardRef as ReactComponent };